import React from 'react';
import Modal from 'react-bootstrap/Modal';

import If from '@components/shared/conditional/If/If';
import EllipsisAnimation from '@components/shared/EllipsisAnimation/EllipsisAnimation';
import ButtonPrimary from '@components/shared/buttons/ButtonPrimary/ButtonPrimary';

import InputTextLabel from '@components/shared/forms/molecules/InputTextLabel/InputTextLabel';

import CloseButton from '../shared/CloseButton/CloseButton';
import styles from './CreateBoardModal.module.scss';

interface ICreateBoardModalProps {
  busy: boolean;
  newBoardName: string;
  onClose: () => void;
  onCreate: () => void;
  setNewBoardName: (newBoardName: string) => void;
}

const CreateBoardPopup = ({
  busy,
  newBoardName,
  setNewBoardName,
  onClose,
  onCreate,
}: ICreateBoardModalProps) => {
  const handleKeyPress = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' && newBoardName.length) {
      onCreate();
    }
  };

  return (
    <Modal
      animation={false}
      data-test="m-create-board-modal"
      dialogClassName={ styles.ModalDialog }
      onHide={ onClose }
      show
    >
      <div className={ styles.Content }>
        <div className={ styles.MainContentWrapper }>
          <div className={ styles.CloseButton }>
            <CloseButton
              className={ styles.CloseButtonButton }
              onClick={ onClose }
            />
          </div>

          <div className={ styles.FormWrapper }>
            <h2 className={ styles.Header }>
              Create a board
            </h2>

            <div className={ styles.NewBoardForm }>
              <div className={ styles.NewBoardName }>
                <InputTextLabel
                  autoFocus
                  className={ styles.NewBoardNameInputText }
                  disabled={ busy }
                  onChange={ (e) => setNewBoardName(e.target.value) }
                  onKeyPress={ handleKeyPress }
                  placeholder="Try 'Cali Cool Dream Home'"
                  title="Board Name"
                  value={ newBoardName }
                />
              </div>
            </div>
          </div>

          <div className={ styles.NewBoardButton }>
            <ButtonPrimary
              disabled={ !newBoardName.length || busy }
              onClick={ onCreate }
            >
              <If condition={ busy }>
                Creating Board
                <EllipsisAnimation />
              </If>
              <If condition={ !busy }>
                Create Board
              </If>
            </ButtonPrimary>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default CreateBoardPopup;
